import { computed, Ref } from 'vue';
import { useI18n } from '@/i18n/i18n';

export type TCourtesyTitle = 0 | 1 | 2 | 3;

export function useCourtesyTitle(): {
  courtesyTitleOptions: Ref<{ value: TCourtesyTitle; label: string }[]>;
  getCourtesyTitle: (value: TCourtesyTitle) => string;
} {

  const { t } = useI18n();

  const courtesyTitleOptions = computed<{ value: TCourtesyTitle; label: string; abbreviation: string }[]>(() => [
    { value: 0, label: t('generics.unspecified'), abbreviation: t('generics.unspecified-abbreviation') },
    { value: 1, label: t('generics.mr'), abbreviation: t('generics.mr-abbreviation') },
    { value: 2, label: t('generics.mrs'), abbreviation: t('generics.mrs-abbreviation') },
  ]);

  const getCourtesyTitle = (value: TCourtesyTitle) => {
    return courtesyTitleOptions.value.find((option) => option.value === value)?.abbreviation || courtesyTitleOptions.value[0].abbreviation;
  };


  return {
    courtesyTitleOptions,
    getCourtesyTitle,
  };
}
